import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "tw:group/badge tw:inline-flex tw:w-fit tw:shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-sm tw:border tw:border-transparent tw:py-0.5 tw:font-medium tw:whitespace-nowrap tw:transition-all tw:focus-visible:border-ring tw:focus-visible:ring-[3px] tw:focus-visible:ring-ring/50 tw:aria-invalid:border-destructive tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:[&>svg]:pointer-events-none",
  {
    variants: {
      variant: {
        default:
          "tw:bg-primary tw:text-primary-foreground tw:[a]:hover:bg-primary/80",
        secondary:
          "tw:bg-secondary tw:text-secondary-foreground tw:[a]:hover:bg-secondary/80",
        destructive:
          "tw:bg-destructive/10 tw:text-destructive tw:focus-visible:ring-destructive/20 tw:dark:bg-destructive/20 tw:dark:focus-visible:ring-destructive/40 tw:[a]:hover:bg-destructive/20",
        success:
          "tw:bg-success/10 tw:text-success tw:dark:bg-success/20 tw:[a]:hover:bg-success/20",
        warning:
          "tw:bg-warning/10 tw:text-warning tw:dark:bg-warning/20 tw:[a]:hover:bg-warning/20",
        outline:
          "tw:border-border tw:text-foreground tw:[a]:hover:bg-muted tw:[a]:hover:text-muted-foreground",
        ghost:
          "tw:hover:bg-muted tw:hover:text-muted-foreground tw:dark:hover:bg-muted/50",
        link: "tw:text-primary tw:underline-offset-4 tw:hover:underline",
      },
      size: {
        sm: "tw:h-4 tw:gap-0.5 tw:px-1 tw:text-[10px] tw:has-data-[icon=inline-end]:pr-0 tw:has-data-[icon=inline-start]:pl-1 tw:[&>svg]:size-2.5!",
        default:
          "tw:h-5 tw:gap-1 tw:px-1.5 tw:text-xs tw:has-data-[icon=inline-end]:pr-0 tw:has-data-[icon=inline-start]:pl-1.5 tw:[&>svg]:size-3!",
        lg: "tw:h-6 tw:gap-1.5 tw:px-2 tw:text-sm tw:has-data-[icon=inline-end]:pr-1 tw:has-data-[icon=inline-start]:pl-2 tw:[&>svg]:size-3.5!",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Badge({
  className,
  variant = "default",
  size = "default",
  code = false,
  render,
  ...props
}) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps(
      {
        className: cn(
          badgeVariants({ variant, size }),
          code && "tw:font-mono",
          className
        ),
      },
      props
    ),
    render,
    state: {
      slot: "badge",
      variant,
      size,
    },
  });
}

export { Badge, badgeVariants };
